import React, { type Dispatch } from 'react';

import { type OnboardingStep } from 'loot-core/shared/onboarding';

export type IOnboardingContextProps = {
  step?: OnboardingStep;
  setStep?: Dispatch<OnboardingStep>;
  goToNextStep?: () => void;
  collectData?: (name: string, categories: string[]) => void;
  setSubmitting?: Dispatch<boolean>;
  submitting?: boolean;
};

export const OnboardingContext: React.Context<IOnboardingContextProps> =
  React.createContext({});
